import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import './css/index.scss';
import MyInput from '../../templates/MyInput';
import MyButton from '../../templates/MyButton';
import DrawingsModal from './components/DrawingsModal';
import Api from '../../Api';
import ViolPhotoModal from './components/ViolPhotoModal';

function PrescriptionViolItem({
  viol, index: violIndex, viols, setViols, violsError, buildObj,
}) {
  const [selectedFilePreview, setSelectedFilePreview] = useState();

  const [isPhotoModalVisible, setIsPhotoModalVisible] = useState(false);
  const [isDrawingsModalVisible, setIsDrawingsModalVisible] = useState(false);

  const previewToShowOnButton = useMemo(() => selectedFilePreview || (viol['picture-file'] ? Api.viols_img_url_no_request + viol['viol-id']
    : '/images/camera.png'), [selectedFilePreview, viol]);

  const updateViols = (index) => (e, newObj) => {
    const newViols = viols.map((item, i) => {
      if (index === i) {
        if (newObj) {
          return { ...item, ...newObj };
        }
        return { ...item, [e.target.name]: e.target.value };
      }
      return item;
    });
    setViols(newViols, true);
  };

  const violsFocusOut = (index) => (ev) => {
    if (!ev.target.value && index !== viols.length - 1) {
      removeViol(index)();
    }
  };

  const removeViol = (index) => () => {
    const violToDelete = viols.find((el, i) => i === index);
    violToDelete['flag-del'] = true;
    setViols([...viols], true);
  };

  useEffect(() => {
    if (!viol.file) {
      setSelectedFilePreview(undefined);
      return;
    }

    setSelectedFilePreview(URL.createObjectURL(viol.file));

    return () => URL.revokeObjectURL(viol.file);
  }, [viol.file]);

  const onCameraClick = () => {
    setIsPhotoModalVisible(true);
  };

  const closePhotoModal = () => {
    setIsPhotoModalVisible(false);
  };

  const closeDrawingsModal = () => {
    setIsDrawingsModalVisible(false);
  };

  const openDrawingsModal = () => {
    setIsDrawingsModalVisible(true);
  };

  const updateViolsDrawing = (drawingData) => {
    const currentViol = viols.find((el, i) => i === violIndex);
    currentViol.drawing = drawingData;
    setViols([...viols], true);
  };

  return (
    <div className="viol_item row">
      <MyInput
        name="text"
        error={violsError}
        className="viol_input_main"
        wrapperClassName="viol_input_item default_size"
        value={viol.text}
        onChange={updateViols(violIndex)}
        onBlur={violsFocusOut(violIndex)}
      />
      <MyButton
        onClick={onCameraClick}
        iconUri={previewToShowOnButton}
        className={`camera_button ${(viol['picture-file'] || selectedFilePreview) && 'with_photo'}`}
        iconClassName="camera_button_image"
        disabled={!viol.text}
      />
      <ViolPhotoModal
        isOpen={isPhotoModalVisible}
        closeFunction={closePhotoModal}
        viol={viol}
        updateViols={updateViols(violIndex)}
      />
      {/* {(viol['picture-file'] || photoPreview) && buildObj?.id && ( */}
      {buildObj?.id && (
        <>
          <MyButton
            className="viol_drawing_button"
            iconUri={viol.drawing ? '/images/viol_drawing_checked.png' : '/images/viol_drawing.png'}
            onClick={openDrawingsModal}
            disabled={!viol.text}
          />
          {viol.text && (
            <DrawingsModal
              viol={viol}
              isOpen={isDrawingsModalVisible}
              closeFunction={closeDrawingsModal}
              updateViolsDrawing={updateViolsDrawing}
              buildObj={buildObj}
            />
          )}
        </>
      )}
      {viol.text && <MyButton className="viol_close_button" iconUri="/images/close.png" onClick={removeViol(violIndex)} />}
    </div>
  );
}

export default PrescriptionViolItem;
